<template>
  <div class="loading-screen" v-if="isNetworkLoading">
      <div class="spinner-container">
        <font-awesome-icon icon="spinner" spin size="3x"  />
      </div>
  </div>
</template>

<script>

export default {
  name: 'loadingIndicator',
  props: ['isNetworkLoading'],
  data: function(){
    return {
      
    }
  },
  computed: {
  },

  components: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style>
.loading-screen {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 2000; /** above modal */
}
.spinner-container {
   position: relative;
   top: 50%;
   transform: translateY(-50%);    
}
</style>
